<template>
    <div>

        <div class="alert alert-info d-flex justify-content-between" v-if="terceiro">
            <div>
                <div class="lead">
                    {{ terceiro.search }}
                </div>
                <div>
                    Informações Complementares
                </div>
            </div>
            <div>
                <a href="#" @click.prevent="$emit('fechar')">
                    <i class="fa-solid fa-angle-left"></i>
                </a>
            </div>
        </div>

        <div>

            <div class="row mb-3">
                <div class="col col-12 col-md-9 d-flex flex-column">
                    <az-input icon="fas fa-search" v-model="search">
                        <template v-slot:buttonposb>
                            <div class="input-group-append">
                                <button class="btn btn-outline-primary" type="button" @click="incluir()">
                                    <i class="fa fa-plus"></i>
                                </button>
                            </div>
                        </template>
                    </az-input>
                </div>
                <div class="col col-12 col-md-3 d-flex flex-column">
                    <div class="btn-group mb-1" role="group" aria-label="Basic example">
                        <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'"
                        @click="viewMode = 'A'">
                            Ativos
                        </button>
                        <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'"
                        @click="viewMode = 'T'">
                            Todos
                        </button>
                    </div>
                </div>
            </div>

        </div>

        <div v-if="( !lista || !lista.length )">
            <az-empty-state
                msg="Nenhuma informação complementar identificada."
                icon="fa-solid fa-circle-question" />
		</div>

        <div v-if="!em_edicao && lista && lista.length">

            <div class="list-group mb-3 az-anime-surgir mb-3">
                <li class="list-group-item d-flex justify-content-between" v-for="(dado, id) in lista" :key="id">
                    <span>
                        <a href="#" @click.prevent="editar(dado)" class="h5 card-link mb-0 mr-3">
                            {{ dado.search }}
                        </a>
                        <span class="badge badge-secondary ml-2">#{{ dado.id_terceiro_info }}</span>
                    </span>
                    <span>
                        <div class="custom-control custom-switch" v-if="viewMode == 'T'">
                            <input type="checkbox" class="custom-control-input"
                                :id="'ativo-' + id"
                                v-model="dado.fl_ativo"
                                @change="toggle(dado)">
                            <label class="custom-control-label" :for="'ativo-' + id"></label>
                        </div>
                        <div v-else>
                            <button type="button" class="btn btn-outline-primary btn-sm" @click="procedimento_lista(dado)">
                                <i class="fa fa-play" aria-hidden="true"></i>
                                <span class="badge badge-primary ml-1" v-if="dado.procedimento_lista_count">
                                    {{ dado.procedimento_lista_count }}
                                </span>
                            </button>
                        </div>
                    </span>
                </li>
            </div>

        </div>

        <!-- Formulário de edição -->
        <div class="modal fade" id="edicaoInfoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" 
                :class="( item && ( item.operadoras && item.js_credenciais && ( item.js_credenciais.enviar_operadoras == 'S' || item.js_credenciais.enviar_operadoras == 'P' ) ) ) ? 'modal-dialog2' : ''" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">
                            Informação Complementar
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="item">
                        <div class="form-row">
                            <div class="col col-12 col-md-9">
                                <az-input
                                    label="Título"
                                    required
                                    :validate="validate"
                                    v-model="item.st_titulo" />
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    label="Id Campo (Klingo)"
                                    required
                                    :validate="validate"
                                    v-model="item.st_id_campo" />
                            </div>
                        </div>

                        <div class="form-row mt-3" v-if="item.js_parametros">
                            <div class="col col-12 col-md-4" v-for="(parm, ipx) in item.js_parametros" :key="ipx">
                                <az-input
                                    :label="ipx"
                                    v-model="item.js_parametros[ipx]" />
                            </div>
                        </div>
                        
                        <template v-if="item.js_depara">
                            <az-sub-title class="mt-3" title="De-Paras" />
                            <div v-if="!item.js_depara.length">Nenhum de-para informado. Será exportado o próprio valor.</div>
                                
                            <div class="form-row" v-for="(depara, idx) in item.js_depara" :key="idx">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        placeholder="De..."
                                        sizing="sm"
                                        :compact="true"
                                        :validate="validate"
                                        required
                                        v-model="depara.de">
                                        <template v-slot:button-pre>
                                            <div class="input-group-prepend">
                                                <button type="button" class="btn btn-outline-danger" @click="item.js_depara.splice(idx, 1)">
                                                    <i class="fa fa-minus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        icon="fas fa-equals"
                                        placeholder="Para..."
                                        sizing="sm"
                                        :compact="true"
                                        :validate="validate"
                                        required
                                        v-model="depara.para" />
                                </div>
                            </div>

                            <button type="button" class="btn btn-sm btn-outline-primary mt-3" @click="item.js_depara.push({ de: '', para: '' })">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </button>
                        </template>

                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button model="terceiroInfo" :id="item.id_terceiro_info" />
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar ()">{{ item.id_terceiro_info ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <procedimento-lista ref="proclista" @refresh="load()" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import AzSubTitle from '../../util/AzSubTitle.vue';
import ProcedimentoLista from '../../shared/ProcedimentoLista.vue';

export default {
    data () {
        return {
            dados: null,
            em_edicao: false,
            item: null,
            validate: false,
            search: "",
            viewMode: "A",
            title: "",
            short_title: "",
            service: "",
            novaOperadora: "", 
            novoPlano: "",
            operadora_search: "", 
            novoCodigoConvenio: "", 
            acao_operadora: "add", 
            lista_de_para: null, 
            id_terceiro: null, 
            import_titulo: "", 
        }
    },

    props: ['cadastro', 'terceiro'],

    components: {
        AzInput,
        AzEmptyState,
        AzSubmit,
        AzAuditLogButton,
        AzSubTitle,
        ProcedimentoLista, 
    },

    computed: {
        lista_opcoes_filtro: function () {
            return [
                {id:'App\\azure\\unidadeOperacao', search:'Unidade', service: 'unidade_operacaos.index'},
            ];
        },

        lista_filtros: function () {

            if ( !this.item )
                return [];

            return this.item.filtros.filter(item => !item.excluido);

        },

        lista: {
            get() {
                let pesquisar = this.search.trim();
                let parts = pesquisar.replace(' ','.*');
                let match = parts;
                let reg = new RegExp(match, 'i');

                return this.dados && this.dados.length ?
                    this.dados.filter (item => {
                        return ( this.viewMode == 'T' || item.fl_ativo ) &&
                            ( !this.search || reg.test(JSON.stringify(item)) );
                    }) : null;
            },
        },

        lista_operadoras: function () { 
            if ( !this.item || !this.item.operadoras )
                return [];

            if ( !this.operadora_search ) 
                return this.item.operadoras;

            const reg = this.$util.getregex(this.operadora_search);

            return this.item.operadoras.filter (item => {
                return ( !item.excluido 
                    && ( !this.operadora_search || !item.id_terceiro_operadora || reg.test(JSON.stringify(item)) ) );
            });

        },

        operadora_filtro_qt: function () { 
            if ( !this.item )
                return "";

            return this.lista_operadoras.filter(item => !item.excluido).length 
                + ' / '
                + this.item.operadoras.filter(item => !item.excluido).length 
        }

    },

    methods: {
        procedimento_lista (item) { 
            this.$refs.proclista.abrir('terceiroInfo', item.id_terceiro_info);
        },
        
        config_servimp () { 
            $('#configServImpModal').modal('show');
        },

        importar() { 
            $('.modal').modal('hide');

            this.id_terceiro = this.item.id_terceiro;
            this.import_titulo = 'de-para ' + this.item.st_terceiro;
            this.$refs.import.iniciar_importacao();
        },

        salvar_de_para () { 
            this.$util.atualizar (this, { 
                service: 'terceiros',
                func: 'salvar_de_para',
                dados: { 
                    lista: this.lista_de_para.data,
                    id_terceiro: this.item.id_terceiro,
                }, 
                modal: 'linkDeParaModal',
                reload: true, 
            });
        },

        carregar_de_para (item) { 
            this.lista_de_para = null; 
            this.item = _.cloneDeep(item);

            $('#linkDeParaModal').modal('show');

            this.$util.load(this, { 
                service: 'terceiros',
                func: 'carregar_de_para_auto',
                parms: { 
                    id_terceiro: item.id_terceiro, 
                },
                loadTo: res => { 
                    this.lista_de_para = res;
                }
            });
        },

        incluir () { 

            this.item = { 
                id_terceiro_info: null,
                id_terceiro: this.terceiro.id_terceiro,
                fl_ativo: true,
                st_titulo : "", 
                st_id_campo: "", 
                js_parametros: {
                    roteiro: "", 
                    pergunta: "", 
                    local: "", 
                }, 
                js_depara: [], 
            };

            this.validate = false;

            $('#edicaoInfoModal').modal('show');    

        },

        adicionarOperadora () { 

            if ( this.novaOperadora ) { 

                if ( ( this.novaOperadora.id_operadora == 1 || this.item.js_credenciais.enviar_operadoras == 'P' ) && !this.novoPlano )
                    return;

                if ( this.acao_operadora == 'copy' ) { 

                    let lista = this.lista_operadoras.filter(item => item.id_terceiro_operadora);

                    if ( !lista.length ) { 
                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: 'Selecione as operadoras de origem para realizar a cópia.', 
                            life: 3000
                        });

                        return;
                    }

                    let teste = _.uniqBy(lista, item => { 
                        return item.id_operadora + '|' + item.id_plano;
                    });

                    if ( teste.length != 1 ) { 

                        this.$toast.add({
                            severity: "error",
                            summary: "Atenção",
                            detail: 'Só pode ter uma operadora selecionada para realizar a cópia.', 
                            life: 3000
                        });

                        return;

                    }

                    lista.forEach(item => {
                        let nova = _.cloneDeep(item);

                        nova.id_terceiro_operadora = null;
                        nova.id_operadora = this.novaOperadora.id_operadora;
                        nova.id_plano = ( this.novoPlano && ( this.novaOperadora.id_operadora == 1 || this.item.js_credenciais.enviar_operadoras == 'P' ) ) ? this.novoPlano.id_plano : null;
                        nova.st_codigo_operadora = this.novoCodigoConvenio;
                        nova.operadora = this.novaOperadora;
                        nova.plano = this.novoPlano;
                        nova.edicao = true;

                        this.item.operadoras.push(nova);
                    });

                    this.novaOperadora =  null;
                    this.novoPlano =  null;

                    this.$nextTick (() => { 
                        this.novaOperadora =  "";
                        this.novoPlano =  "";
                    });

                    return;

                }

                this.item.operadoras.push({
                    id_terceiro_operadora: null, 
                    id_terceiro: this.item.id_terceiro,
                    id_operadora: this.novaOperadora.id_operadora,
                    id_plano: ( this.novoPlano && ( this.novaOperadora.id_operadora == 1 || this.item.js_credenciais.enviar_operadoras == 'P' ) ) ? this.novoPlano.id_plano : null, 
                    id_unidade_operacao: "", 
                    st_codigo_operadora: this.novoCodigoConvenio,
                    st_codigo_setor: "", 
                    fl_enviar_valor: this.novoCodigoConvenio ? true : false, 
                    operadora: this.novaOperadora,
                    plano: this.novoPlano, 
                    excluido: false, 
                    edicao: true, 
                });

                this.novaOperadora =  null;
                this.novoPlano =  null;

                this.$nextTick (() => { 
                    this.novaOperadora =  "";
                    this.novoPlano =  "";
                });

            }

        },

        load () {
            this.$util.load(this, {
                service:'terceiro_infos',
                func: 'index',
                parms: { 
                    cadastro: true, 
                    id_terceiro: this.terceiro ? this.terceiro.id_terceiro : -1,
                }
            });
        },
        editar (item) {
            this.validate = false;
            this.item = _.cloneDeep (item);

            $('#edicaoInfoModal').modal('show');
        },
        atualizar () {
            this.$util.atualizar(this, {
                service: 'terceiro_infos',
                dados: this.item,
                reload: true,
                modal: 'edicaoInfoModal',
            });
        },

        fechar () {
            // Fecha o modal de edição
            $('#edicaoInfoModal').modal('hide');    
        },

        toggle (item) {

            this.$util.toggle(this, {
                service: 'terceiro_infos',
                dados: item,
            });

        },
    },

}
</script>

<style scoped>
.modal-dialog2 {
  width: 98% !important;
  min-height: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}
</style>
